type PulseDesktopPaginationProps = {
  /** Index of the active article */
  activeArticle: number;
  /** Total number of articles to be displayed */
  totalCards: number;
};

/** Pulse number pagination for mobile, desktop */
const PulsePagination = ({
  activeArticle,
  totalCards,
}: PulseDesktopPaginationProps): React.ReactElement => {
  return (
    <div className="flex items-center justify-center text-center font-poppins text-white lg:pb-1">
      <span className="text-xl font-medium lg:text-4xl">{activeArticle}</span>

      <span className="mx-1 inline-block text-base">of</span>

      <span className="text-xl font-medium leading-150 lg:text-4xl">
        {totalCards}
      </span>
    </div>
  );
};

export default PulsePagination;
